import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    question: '¿Necesito estar medicado para que esto funcione?',
    answer: 'No, el método se basa en principios de física y comportamiento aplicables a cualquier nivel de estimulación.'
  }, {
    question: '¿Es muy largo de leer?',
    answer: 'No. Está diseñado para cerebros con TDAH: directo, con puntos clave y sin paja innecesaria.'
  }, {
    question: '¿Sirve para tareas del hogar o solo para el trabajo?',
    answer: 'Sirve para cualquier cosa que te provoque parálisis, desde lavar los platos hasta escribir una tesis.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 md:py-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-31">
      <FadeIn data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-34">
            Preguntas Frecuentes
          </h2>
        </div>
      </FadeIn>

      <div className="space-y-4" data-id="element-35">
        {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-36">
            <div className={`border rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-amber-500/50 bg-slate-800/50' : 'border-slate-700/50 bg-slate-800/20 hover:border-slate-600'}`} data-id="element-37">
              <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-38">
                <span className="text-lg font-medium text-white pr-4" data-id="element-39">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-amber-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-41">
                <p className="text-slate-300 leading-relaxed" data-id="element-42">{faq.answer}</p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}